import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Component, ElementRef, EventEmitter, forwardRef, Input, ViewChild} from "@angular/core";


export const AMOUNT_RANGE_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AmountRangeComponent),
    multi: true
};

@Component({
    selector: 'tfl-amount-range',
    providers: [AMOUNT_RANGE_CONTROL_VALUE_ACCESSOR],
    template: `
    <div style="display: flex">
        <input #minInput
            class="form-control range-amount"
            (input)="onInput()"
            (blur)="onAmountBlur(false)"
            style="width: 100px;margin-left: 10px"
            id="minValue"
            [name]="minValueName"
            type="money"
        />
        <label for="maxAmount" class="control-label" style="margin: 0 5px 0 5px;">
            &#9866;
        </label>
        <input #maxInput
               (blur)="onAmountBlur(true)"
               class="form-control range-amount"
               style="width: 100px"
               (input)="onInput()"
               maxlength="50"
               id="maxValue"
               [name]="maxValueName"
               type="money"
        />
    </div>
    `,
    styles: [`
        input {
            margin:0 !important; 
            width: 50% !important;
        };
    `]
})

export class AmountRangeComponent implements ControlValueAccessor {

    @Input('id') id: string;
    @Input('name') name: string;
    @Input('minValueName') minValueName: string;
    @Input('maxValueName') maxValueName: string;
    @ViewChild('maxInput') maxInput: ElementRef;
    @ViewChild('minInput') minInput: ElementRef;

    onChange: EventEmitter<any> = new EventEmitter<any>();
    onTouchedCallback: EventEmitter<any> = new EventEmitter<any>();
    value: {} = {};

    registerOnChange(fn: any): void {
        this.onChange.subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback.subscribe(fn);
    }

    writeValue(obj: any): void {
        if (obj && obj.hasOwnProperty(this.minValueName) && obj.hasOwnProperty(this.maxValueName)) {
            this.value = {
                [this.maxValueName]: obj[this.maxValueName],
                [this.minValueName]: obj[this.minValueName]
            };

            if (!!this.maxInput && !!this.minInput) {
                this.maxInput.nativeElement.value = obj[this.maxValueName];
                this.minInput.nativeElement.value = obj[this.minValueName];
            }
        } else if (!obj) {
            // Form reset: clear both inputs
            this.value = {};
            if (!!this.maxInput && !!this.minInput) {
                this.maxInput.nativeElement.value = '';
                this.minInput.nativeElement.value = '';
            }
        }
    }

    onAmountBlur(min: boolean) {
        let minAmount = this.minInput.nativeElement.value;
        let maxAmount = this.maxInput.nativeElement.value;
        if (minAmount && maxAmount) {
            if (Number(minAmount) > Number(maxAmount)) {
                if (min) {
                    this.maxInput.nativeElement.value = '';
                    this.value = {
                        minValue: this.minInput.nativeElement.value,
                        maxValue: ''
                    };
                    this.onChange.emit(this.value);
                } else {
                    this.minInput.nativeElement.value = '';
                    this.value = {
                        minValue: '',
                        maxValue: this.maxInput.nativeElement.value
                    };
                    this.onChange.emit(this.value);
                }
            }
        }
    }

    onInput() {
        this.onChange.emit(this.value = {
            minValue: this.minInput.nativeElement.value,
            maxValue: this.maxInput.nativeElement.value
        });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/amount-range.component.ts